import { Res } from 'common/types/responses'
import { Req } from 'common/types/requests'
import { service } from 'common/service'
import { getStore } from 'common/store'
import { companyService } from './useCompany'
import { subscriptionService } from './useSubscription'

export const uboVeriffService = service
  .enhanceEndpoints({ addTagTypes: ['UboVeriff'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      createUboVeriff: builder.mutation<
        Res['uboVeriff'],
        Req['createUboVeriff']
      >({
        invalidatesTags: [{ id: 'LIST', type: 'UboVeriff' }],
        query: (query: Req['createUboVeriff']) => ({
          body: query.data,
          method: 'POST',
          url: `partners/company/${query.company_id}/subscriptions/${query.subscription_id}/verifications`,
        }),
      }),
      deleteUboVeriff: builder.mutation<
        Res['uboVeriff'],
        Req['deleteUboVeriff']
      >({
        invalidatesTags: [{ id: 'LIST', type: 'UboVeriff' }],
        query: (query: Req['deleteUboVeriff']) => ({
          body: query,
          method: 'DELETE',
          url: `partners/company/${query.company_id}/subscriptions/${query.subscription_id}/verifications/${query.id}`,
        }),
        transformResponse: (res) => {
          getStore().dispatch(companyService.util.invalidateTags(['Company']))
          getStore().dispatch(
            subscriptionService.util.invalidateTags(['Subscription']),
          )
          return res
        },
      }),
      getUboVeriffs: builder.query<Res['uboVeriffs'], Req['getUboVeriffs']>({
        providesTags: [{ id: 'LIST', type: 'UboVeriff' }],
        query: (query) => ({
          url: `partners/company/${query.company_id}/subscriptions/${query.subscription_id}/verifications`,
        }),
      }),
      updateUboVeriff: builder.mutation<
        Res['uboVeriff'],
        Req['updateUboVeriff']
      >({
        invalidatesTags: (res) => [
          { id: 'LIST', type: 'UboVeriff' },
          { id: res?.id, type: 'UboVeriff' },
        ],
        query: (query: Req['updateUboVeriff']) => ({
          body: query.data,
          method: 'PUT',
          url: `partners/company/${query.company_id}/subscriptions/${query.subscription_id}/verifications/${query.data.id}`,
        }),
        transformResponse: (res) => {
          getStore().dispatch(companyService.util.invalidateTags(['Company']))
          getStore().dispatch(
            subscriptionService.util.invalidateTags(['Subscription']),
          )
          return res
        },
      }),
      // END OF ENDPOINTS
    }),
  })

export async function createUboVeriff(
  store: any,
  data: Req['createUboVeriff'],
  options?: Parameters<
    typeof uboVeriffService.endpoints.createUboVeriff.initiate
  >[1],
) {
  return store.dispatch(
    uboVeriffService.endpoints.createUboVeriff.initiate(data, options),
  )
}
export async function deleteUboVeriff(
  store: any,
  data: Req['deleteUboVeriff'],
  options?: Parameters<
    typeof uboVeriffService.endpoints.deleteUboVeriff.initiate
  >[1],
) {
  return store.dispatch(
    uboVeriffService.endpoints.deleteUboVeriff.initiate(data, options),
  )
}

export async function updateUboVeriff(
  store: any,
  data: Req['updateUboVeriff'],
  options?: Parameters<
    typeof uboVeriffService.endpoints.updateUboVeriff.initiate
  >[1],
) {
  return store.dispatch(
    uboVeriffService.endpoints.updateUboVeriff.initiate(data, options),
  )
}
export async function getUboVeriffs(
  store: any,
  data: Req['getUboVeriffs'],
  options?: Parameters<
    typeof uboVeriffService.endpoints.getUboVeriffs.initiate
  >[1],
) {
  return store.dispatch(
    uboVeriffService.endpoints.getUboVeriffs.initiate(data, options),
  )
}
// END OF FUNCTION_EXPORTS

export const {
  useCreateUboVeriffMutation,
  useDeleteUboVeriffMutation,
  useGetUboVeriffsQuery,
  useUpdateUboVeriffMutation,
  // END OF EXPORTS
} = uboVeriffService

/* Usage examples:
const { data, isLoading } = useGetUboVeriffQuery({ id: 2 }, {}) //get hook
const [createUboVeriff, { isLoading, data, isSuccess }] = useCreateUboVeriffMutation() //create hook
uboVeriffService.endpoints.getUboVeriff.select({id: 2})(store.getState()) //access data from any function
*/
